import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCompany } from '../contexts/CompanyContext';
import { hasCompanyAccess } from '../lib/trial';

/**
 * Оборачивает разделы, недоступные при истёкшем триале или неактивной
 * подписке (отменена/заморожена/приостановлена) — всё, кроме Дашборда,
 * Отчётов и Биллинга. Проверка только на фронтенде в этой фазе — backend
 * получит такую же проверку в одном из следующих раундов.
 */
export default function TrialLockedRoute({ children }) {
  const { currentCompany } = useCompany();

  if (!hasCompanyAccess(currentCompany)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
